<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import versionApi from '@/api/version';
  import store from '@/store';

  export default {
    mounted() {
      this.getVersion();
    },
    methods: {
      async getVersion() {
        /**
         * @type import('axios').AxiosResponse<{ version: string, deployment: string }>
         */
        let title = 'Complife SAMI';
        const response = await versionApi.getVersion();
        const { version, deployment } = response.data;

        await store.dispatch('setVersion', version);
        await store.dispatch('setDeployment', deployment);

        if (deployment && deployment !== '' && deployment !== 'production') {
          title += ` - ${deployment}`;
        }

        document.title = title;

        return { version, deployment };
      },
    },
  };
</script>

<style lang="scss">
  @import '@/assets/index.scss';
</style>
